// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsInvoices_GerarParaOrdemServicoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/invoices/gerar-para-ordem-servico/{id}
 * Empty Input — id is URL path parameter, body has no fields.
 */
import { registerContract } from './validate'

export interface SubaccountsInvoices_GerarParaOrdemServicoInput {}

registerContract('SubaccountsInvoices_GerarParaOrdemServicoInput', {})
